module.exports = __webpack_public_path__ + "img/upload-resume.52d2105e.svg";